export default function CustomerStyle(){
    const customStyles = {
        table: {
            style: {
              width: "100%",
            },
        },
        headRow: {
            style: {
                backgroundColor: '#313a46',
                minHeight: '48px',
                borderTopLeftRadius: '10px',
                borderTopRightRadius: '10px',
                borderBottomWidth: '0',
            }
        },
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: '#ffffff',
            }
        },
        rows: {
            style: {
                fontSize: '13px',
                minHeight: '46px',
                borderBottomColor: '#eef1f5',
            },
            highlightOnHoverStyle: {
                backgroundColor: '#f4f6fb',
                transitionDuration: '0.15s',
                transitionProperty: 'background-color',
                cursor: 'pointer',
            },
            stripedStyle: {
                backgroundColor: '#fafbfd',
            },
        },
        cells: {
            style: {
              fontSize: "13px",
              padding: "12px 10px",
            },
          },
        pagination: {
            style: {
                borderTop: '1px solid #eef1f5',
                fontSize: '13px',
                color: '#5b6472',
            },
        },
    };

    return customStyles;
}
